import { HStack, Link } from '@chakra-ui/react'
import { Connect } from '../Connect/Connect'
import { NavButton } from '../NavBar/NavButton'

export const TopNav = () => {
  return (
    <HStack maxW={"8xl"} mx="auto" px="2" py="5" justifyContent="space-around">
      <NavButton fontWeight='500' as={Link} href="https://www.stackd.finance/" isExternal label="Home" />
      <NavButton fontWeight='500' as={Link} href="https://www.stackd.finance/#Tokenomics" isExternal label="Tokenomics" />
      <NavButton fontWeight='500' as={Link} href="https://www.stackd.finance/#Roadmap" isExternal label="Roadmap" />
      <NavButton fontWeight='500' as={Link} href="https://www.stackd.finance/team" isExternal label="Team" />
      <NavButton fontWeight='500' as={Link} href="https://www.stackd.finance/white-paper" isExternal label="Whitepaper" />
      <Connect />
    </HStack>
  )
}